import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/shadcn/breadcrumb'
import { useRestClient } from '@/contexts/QueryProvider'
import { IconRightChevronOutline } from '@icons/IconRightChevronOutline'
import { Link, useParams } from 'react-router'
// import { dagsterAppsMockData } from './PlatformDagsterPage/dagsterAppsMockData'

export function PlatformBreadcrumbs({ title }: { title: string }) {
  const { applicationId } = useParams()
  const { getDagsterApiGetDagsterApps } = useRestClient()
  const { data: dagsterApps } = getDagsterApiGetDagsterApps.useSuspenseQuery(undefined, {
    // select: () => dagsterAppsMockData,
  })
  const dagsterApp = applicationId ? dagsterApps.find((app) => app.applicationId === Number(applicationId)) : undefined
  const breadcrumbLink = dagsterApp
    ? {
        label: 'Dagster',
        page: `/platform/dagster`,
      }
    : undefined
  return (
    <Breadcrumb className="backdrop-blur">
      <BreadcrumbList>
        <BreadcrumbItem>
          <BreadcrumbPage>Platform</BreadcrumbPage>
        </BreadcrumbItem>
        <BreadcrumbSeparator>
          <IconRightChevronOutline />
        </BreadcrumbSeparator>
        <BreadcrumbItem>
          {breadcrumbLink ? (
            <BreadcrumbLink asChild>
              <Link to={breadcrumbLink.page}>{breadcrumbLink.label}</Link>
            </BreadcrumbLink>
          ) : (
            <BreadcrumbPage>{title}</BreadcrumbPage>
          )}
        </BreadcrumbItem>
        {dagsterApp && (
          <>
            <BreadcrumbSeparator>
              <IconRightChevronOutline />
            </BreadcrumbSeparator>
            <BreadcrumbItem>
              <BreadcrumbPage>{dagsterApp.appName}</BreadcrumbPage>
            </BreadcrumbItem>
          </>
        )}
      </BreadcrumbList>
    </Breadcrumb>
  )
}
